module.exports = __webpack_public_path__ + "static/media/flutter.180d53e4.jpg";